function Fallback() {
  return <div />;
}

export default Fallback;
